/**
 * Returns relevant error message data for HTTP requests. Good for parsing out more details from HTTP requests rather
 * then just top level messages. Will return error name and message if other error type.
 * @param error
 * @returns {{code: *, statusText: *, message: *, status: *}|{code: *, success: *, message: *, status: *}|{message: string}}
 */
export function getErrorMessage(error) {
  if (!error) return {};

  // this is an AXIOS HTTP request response error, it actually hit the endpoint, takes first element from errors list.
  const currentError = error?.response?.data?.errors?.[0] || "";
  if (currentError) {
    const { status, statusText } = error.response;
    return { message: currentError.error, code: currentError.code, status, statusText };
  }

  // this is a request error, failed at endpoint.
  const errorMessage = error?.response?.data?.internal_error_message || error?.response?.data?.error || "";
  if (errorMessage) {
    const { status, httpStatus, success } = error.response.data;
    return { message: errorMessage, code: httpStatus, status, success };
  }

  // this will select OAPI and visitor service errors
  if (error?.response?.data?.message) {
    const { status } = error.response;
    return { message: error.response.data.message, status };
  }

  // default return value if not AXIOS HTTP request
  const result = {
    message: isError(error) ? error.toString() : JSON.stringify(error)
  };

  return result;
}

export function isError(error) {
  return error && error.stack && error.message;
}
